import { Component, inject, Input, OnInit } from '@angular/core';
import { IProduct } from '../../../../../IProduct';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { P0003601EnSavoirPlusComponent } from '../../../../P0003601/EnSavoirPlus/p0003601-en-savoir-plus/p0003601-en-savoir-plus.component';
import {
  getLabelConfigurationWarningModeFromACU,
  getPoolMasterClass,
} from '../../../../../../ECoSystemsHelper';
import { P00030 } from '../../../../P00030';
import { P00032 } from '../../../../P00032';
import { FunctionParametersSettingClockWeekVSScreenComponent } from '../../../../P0003601/Component/function-parameters-setting-clock-week-vsscreen/function-parameters-setting-clock-week-vsscreen.component';
import { FunctionParametersSettingClockVSScreenComponent } from '../../../../P0003601/Component/function-parameters-setting-clock-vsscreen/function-parameters-setting-clock-vsscreen.component';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import {
  LabelConfigurationComponent,
  LabelConfigurationWarningMode,
} from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { TranslatePipe } from '@ngx-translate/core';
import { P00037ConsigneManuel } from '../../../Enum/P00037ConsigneManuel';
import { InformationTitleComponent } from '../../../../../../../../components/ecosystems/information-title/information-title.component';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';
import { LargedLinkComponent } from '../../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { TwoChoicesControlComponent } from '../../../../../../../../components/ecosystems/two-choices-control/two-choices-control.component';
import { FunctionEnSavoirPlusModalComponent } from '../../../../../../../../components/ecosystems/function-en-savoir-plus-modal/function-en-savoir-plus-modal.component';
import { FunctionParametersSettingsClockScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-settings-clock-screen/function-parameters-settings-clock-screen.component';
import { FunctionParametersSettingClockWeekScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-setting-clock-week-screen/function-parameters-setting-clock-week-screen.component';
import { P00037TauxAbaissement } from '../../../Enum/P00037TauxAbaissement';
import { SwitchConfigurationComponent } from '../../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { P00037HysteresisRegulationRx } from '../../../Enum/P00037HysteresisRegulationRx';
import { P00037ConsigneRegulationRxEnum } from '../../../Enum/P00037ConsigneRegulationRx';
import { P00037ESPInstallationClComponent } from '../../../EnSavoirPlus/p00037-espinstallation-cl/p00037-espinstallation-cl.component';
import { P00037TemperatureHivernage } from '../../../Enum/P00037TemperatureHivernage';
import { getTemperatureType } from '../../../../../../helper/temperature';
import { FunctionParametersSettingClockWeekSaltScreenComponent } from '../../../Component/function-parameters-setting-clock-week-salt-screen/function-parameters-setting-clock-week-salt-screen.component';
import { FunctionParametersSettingsClockSaltScreenComponent } from '../../../Component/function-parameters-settings-clock-salt-screen/function-parameters-settings-clock-salt-screen.component';

@Component({
  selector: 'app-p00037-electrolyseur-parameters',
  templateUrl: './p00037-electrolyseur-parameters.component.html',
  styleUrls: ['./p00037-electrolyseur-parameters.component.scss'],
  imports: [
    LabelConfigurationComponent,
    TranslatePipe,
    InformationTitleComponent,
    LabelDescriptionComponent,
    LargedLinkComponent,
    TwoChoicesControlComponent,
    SwitchConfigurationComponent,
  ],
})
export class P00037ElectrolyseurParametersComponent implements OnInit {
  @Input() productClass: IProduct | null = null;

  private slideModalService: SlideModalController =
    inject(SlideModalController);

  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {
    this.openEnSavoirPlus = this.openEnSavoirPlus.bind(this);
    this.EnSavoirPlusPage = this.EnSavoirPlusPage.bind(this);
    this.P00037ESPInstallationClModal =
      this.P00037ESPInstallationClModal.bind(this);
  }

  async openEnSavoirPlus() {
    const modal = await this.slideModalService.create({
      component: FunctionEnSavoirPlusModalComponent,
      componentProps: {
        description: 'P00037.programmation.ensavoirplus',
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  getPool() {
    return this.edroNetworkManager.getPoolContext().pool!;
  }

  async EnSavoirPlusPage() {
    const modal = await this.slideModalService.create({
      component: FunctionEnSavoirPlusModalComponent,
      componentProps: {
        description: 'P00037.reglage.hivernageESP.' + getTemperatureType(),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  getProductDeviceTableFromPool() {
    const pool = this.edroNetworkManager.getPoolContext().pool!;
    const master = getPoolMasterClass(pool);
    return master!.getProductDeviceTableFromPool(pool!).firmwareVersion < 6
      ? LabelConfigurationWarningMode.NEED_UPDATE
      : master!.getProductDeviceTableFromPool(pool!).firmwareVersion == 6
        ? LabelConfigurationWarningMode.NEW
        : LabelConfigurationWarningMode.NONE;
  }

  async goToFunctionParametersSettingsClockScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingsClockSaltScreenComponent,
      componentProps: {
        value: [
          this.actionStack!.getValue('elPHorlogeLundi'),
          this.actionStack!.getValue('elPHorlogeMardi'),
          this.actionStack!.getValue('elPHorlogeMercredi'),
          this.actionStack!.getValue('elPHorlogeJeudi'),
          this.actionStack!.getValue('elPHorlogeVendredi'),
          this.actionStack!.getValue('elPHorlogeSamedi'),
          this.actionStack!.getValue('elPHorlogeDimanche'),
        ],
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.SALT_Parametrage2,
        'elPHorlogeLundi',
        hj[0],
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.SALT_Parametrage2,
        'elPHorlogeMardi',
        hj[1],
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.SALT_Parametrage3,
        'elPHorlogeMercredi',
        hj[2],
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.SALT_Parametrage3,
        'elPHorlogeJeudi',
        hj[3],
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.SALT_Parametrage4,
        'elPHorlogeVendredi',
        hj[4],
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.SALT_Parametrage4,
        'elPHorlogeSamedi',
        hj[5],
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.SALT_Parametrage5,
        'elPHorlogeDimanche',
        hj[6],
      );
      this.actionStack!.commit();
    }
  }

  async goToFunctionParametersSettingClockWeekScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingClockWeekSaltScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('elPHorlogeSemaine'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;
      this.actionStack!.editValue(
        P00039DataRxTxIndex.SALT_Parametrage5,
        'elPHorlogeSemaine',
        hj,
      );
      this.actionStack!.commit();
    }
  }

  async P00037ESPInstallationClModal() {
    const modal = await this.slideModalService.create({
      component: P00037ESPInstallationClComponent,
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  hasProduitP00032() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00032()) ?? 0;
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P00037ConsigneManuel = P00037ConsigneManuel;
  protected readonly P00037TauxAbaissement = P00037TauxAbaissement;
  protected readonly P00037HysteresisRegulationRx =
    P00037HysteresisRegulationRx;
  protected readonly P00037ConsigneRegulationRxEnum =
    P00037ConsigneRegulationRxEnum;
  protected readonly P00037TemperatureHivernage = P00037TemperatureHivernage;
  protected readonly getLabelConfigurationWarningModeFromACU =
    getLabelConfigurationWarningModeFromACU;
}
